import React, { Component } from 'react';
import './App.css';
import './pages/Page.css';

import Authentication from './Authentication';
import Notification from './components/Notification';


import cookie from 'react-cookies';

import { Link } from 'react-router';
import RSSicon from './images/RSS_icon-dark.svg';
import RSSlogo from './images/RSS_logo-dark.svg';

class App extends Component {

  constructor(props) {
    super(props);
    
    this._clickOutside = this._clickOutside.bind(this);
    this._signIn = this._signIn.bind(this);
    this._signOut = this._signOut.bind(this);
    this._toggleShowMenu = this._toggleShowMenu.bind(this);

    this.state = {
      notificationText:"",
      showMenu:false,
      signedIn:localStorage.getItem('user_id'),
      token:this.props.params.token
    };

  }

  componentDidMount() {
    if (this.props.params.subdomain) { // url is /signout/:subdomain
      this.props.router.replace('/'); // remove signout/:subdomain from url
      this._signOut();
    }
  }

  componentWillMount() {
    document.addEventListener('mousedown',this._clickOutside,false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown',this._clickOutside,false);
  }

  _clickOutside(e) {
    if (this.state.signedIn > 0 && !this.refs.appmenu.contains(e.target) && this.state.showMenu) {
      this._toggleShowMenu();
    }
  }

  render() {
    
      var pages = this.props.children;
      if (this.state.signedIn < 1 && !this.props.params.token) {
        pages = <Authentication success={this._signIn} token={this.state.token} referrallink={this.props.params.referrallink} />;
      }

      return (

        <div>
          <Notification text={this.state.notificationText} />
          <div className="App">

            {this.state.signedIn > 0 ? <div>
              <ul ref="appmenu" className="App-menu">
                <li className="logo"><img src={RSSlogo} alt="Really Simple Store" /></li>
                <li className={this.state.showMenu ? "hover" : "" }><span onClick={this._toggleShowMenu}>Account | <strong>Menu</strong> ▾</span><ul>
                  <li>{localStorage.getItem("email")}</li>
                  <li><Link to="/">Manage Stores</Link></li>
                  <li style={{display:'none'}}><Link to="/referrals">Referral Program</Link></li>
                  <li><Link to="/info">Profile Info</Link></li>
                  <li><hr /></li>
                  <li><a onClick={this._signOut}>Sign Out</a></li>
                </ul></li>
              </ul>
            </div> : null }
            {pages}

          </div>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
      );
  
  }

  _signIn(e) {
    this.setState({
      notificationText:""
    },function() {
      this.setState({
        notificationText:"Signed in!",
        signedIn:localStorage.getItem('user_id'),
        studio_id:localStorage.getItem('studio_id')
      });
    }.bind(this));
  }

  _signOut(e) {
    this.setState({
      signedIn:0,
    });
    localStorage.setItem('user_id','0');
    localStorage.setItem('name','');
    //localStorage.setItem('email',''); // keep to pre-fill sign in next time
    localStorage.setItem('image','');
    localStorage.setItem('token','');

    cookie.remove("user_id",{ path : '/'});
    cookie.remove("user_id",{ path : '/',domain : 'reallysimplestore.com'});
    cookie.remove("user_token",{ path : '/'});
    cookie.remove("user_token",{ path : '/',domain : 'reallysimplestore.com'});
  }

  _toggleShowMenu() {
    this.setState({
      showMenu:!this.state.showMenu
    });
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js